<template>
    <el-select
      :title="multiple? optionData.name : ''"
      ref="select"
      v-model="value"
      placeholder="请选择"
      size="mini"
      clearable
      :disabled="disabled"
      :filterable="filterable"
      :filter-method="filterMethod"
      style="width: 100%;"
      @clear="clear"
      @visible-change="visibleChange"
    >
      <el-option
        ref="option"
        class="tree-select__option"
        :value="optionData.id"
        :label="optionData.name"
      >
        <el-tree
          ref="tree"
          class="tree-select__tree"
          :class="`tree-select__tree--${multiple ? 'checked' : 'radio'}`"
          :node-key="props.id"
          :data="data"
          :props="props"
          :default-expanded-keys="[value]"
          :show-checkbox="multiple"
          :highlight-current="!multiple"
          :expand-on-click-node="multiple"
          :filter-node-method="filterNode"
          @node-click="handleNodeClick"
          @check-change="handleCheckChange"
        ></el-tree>
      </el-option>
    </el-select>
  </template>
  
  <script>
  export default {
    name: 'TreeSelect',
    props: {
      // v-model绑定
      value: {
        type: [String, Number],
        default: ''
      },
      multiple: {
        type: Boolean,
        default: false
      },
      // 树形的数据
      data: {
        type: Array,
        default: function () {
          return []
        }
      },
      filterable: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      // tree的props配置
      props: {
        type: Object,
        default: function () {
          return {
            id: "id",
            label: 'label',
            children: 'children'
          }
        }
      }
    },
    data() {
      return {
        optionData: {
          id: '',
          name: ''
        },
        filterFlag: false
      }
    },
    watch: {
      value: {
        immediate: true,
        handler(val) {
          console.log(val);
          // 回显数据
          this.$nextTick(() => {
            if (!this.isEmpty(this.data)) {
              this.init(val)
            }
          });
        },
        immediate: true
      },
      data: function (val) {
        if (!this.isEmpty(val)) {
          this.init(this.value)
        }
      }
    },
    created() {      
    },
    methods: {
      // 是否为空
      isEmpty(val) {
        for (let key in val) {
          return false
        }
        return true
      },
      handleNodeClick(data) {
        if (this.multiple) {
          return
        }
        console.log(11);
        if(!data[this.props.children]){
          this.$emit('input', data[this.props.id])
          this.$refs.select.visible = false
        }
      },
      handleCheckChange() {
        const nodes = this.$refs.tree.getCheckedNodes()
        const value = nodes.map((item) => item[this.props.id]).join(',')
        this.$emit('input', value)
      },
      init(val) {
        // 多选        
        if (this.multiple) {          
          const arr = val.toString().split(',')
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(arr)
            const nodes = this.$refs.tree.getCheckedNodes()
            this.optionData.id = val
            this.optionData.name = nodes
              .map((item) => item[this.props.label])
              .join(',')
          })
        }
        // 单选
        else {
          val = val === '' ? null : val
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(val)
              if (val === null) {
                return
              }
              const node = this.$refs.tree.getNode(val)
              this.optionData.id = val
              this.optionData.name = node.label
            })
        }
      },
      visibleChange(e) {
        if (e) {
          const tree = this.$refs.tree
          this.filterFlag && tree.filter('')
          this.filterFlag = false
          let selectDom = null
          if(this.multiple) {
            selectDom = tree.$el.querySelector('.el-tree-node.is-checked')
          } else {
            selectDom = tree.$el.querySelector('.is-current')
          }
          setTimeout(() => {
            this.$refs.select.scrollToOption({ $el: selectDom })
          }, 0)
        }
      },
      clear() {
        this.$emit('input', '')
      },
      filterMethod(val) {
        this.filterFlag = true
        this.$refs.tree.filter(val)
      },
      filterNode(value, data) {
        if (!value) return true
        const label = this.props.label || 'name'
        return data[label].indexOf(value) !== -1
      }
    }
  }
  </script>
  
  <style>
  .el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
    height: auto;
    max-height: 300px;
    padding: 0;
    overflow: hidden;
    overflow-y: auto;
  }
  .el-select-dropdown__item.selected {
    font-weight: normal;
  }
  ul li >>> .el-tree .el-tree-node__content {
    height: auto;
    padding: 0 20px;
  }
  .el-tree-node__label {
    font-weight: normal;
  }
  .el-tree >>> .is-current .el-tree-node__label {
    color: #409eff;
    font-weight: 700;
  }
  .el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
    color: #606266;
    font-weight: normal;
  }
  .maxwidth {
    width: 100%;
  }
  </style>